export const MEMBERSHIP_SET_MEMBERSHIP_GROUPS = 'membershipSetMembershipGroups'

// CSV Approval queue
export const MEMBERSHIP_SET_CSV_ROWS_ON_APPROVAL_QUEUE = 'membershipSetCSVRowsOnApprovalQueue'
export const MEMBERSHIP_RESET_MEMBER_CSV_APPROVAL_QUEUE = 'membershipResetMemberCSVApprovalQueue'
export const MEMBERSHIP_PUSH_CSV_ROW_ONTO_APPROVAL_QUEUE = 'membershipPushCSVRowOntoApprovalQueue'
export const MEMBERSHIP_UPDATE_CSV_ROW_ON_APPROVAL_QUEUE = 'membershipUpdateCSVRowOnApprovalQueue'
export const MEMBERSHIP_TOGGLE_INVITE_ON_APPROVAL_QUEUE = 'membershipToggleInviteOnApprovalQueue'
export const MEMBERSHIP_SET_IMPORT_ALL_AS_ON_APPROVAL_QUEUE = 'membershipSetImportAllAsOnApprovalQueue'
export const MEMBERSHIP_SET_ADD_ALL_TO_ON_APPROVAL_QUEUE = 'membershipSetAddAllToOnApprovalQueue'
export const MEMBERSHIP_REMOVE_CSV_ROW_FROM_APPROVAL_QUEUE = 'membershipRemoveCSVRowFromApprovalQueue'
export const MEMBERSHIP_RESET_CSV_APPROVAL_QUEUE = 'membershipResetCSVApprovalQueue'

// Access Requests
export const MEMBERSHIP_SET_PENDING_ACCESS_REQUESTS = 'membershipSetPendingAccessRequests'
export const MEMBERSHIP_QUEUE_APPROVAL_FOR_ACCESS_REQUEST = 'membershipQueueApprovalForAccessRequest'
export const MEMBERSHIP_REMOVAL_APPROVAL_FOR_ACCESS_REQUEST = 'membershipRemoveApprovalForAccessRequest'
export const MEMBERSHIP_REMOVE_GROUP_FROM_PENDING_ACCESS_REQUEST = 'membershipRemoveGroupFromPendingAccessRequest'
export const MEMBERSHIP_UPDATE_PENDING_ACCESS_REQUEST_GROUPS = 'membershipUpdatePendingAccessRequestGroups'
export const MEMBERSHIP_REJECT_PENDING_ACCESS_REQUEST = 'membershipRejectPendingAccessRequest'
export const MEMBERSHIP_RESET_PENDING_ACCESS_REQUEST_QUEUE = 'membershipResetPendingAccessRequestQueue'

export const MEMBERSHIP_OPEN_CREATE_MEMBERSHIP_GROUP_MODAL = 'membershipOpenCreateMembershipGroupModal'
export const MEMBERSHIP_CLOSE_CREATE_MEMBERSHIP_GROUP_MODAL = 'membershipCloseCreateMembershipGroupModal'

export const MEMBERSHIP_OPEN_ADD_MEMBERS_TO_MEMBERSHIP_GROUP_MODAL = 'membershipOpenAddMembersToMembershipGroupModal'
export const MEMBERSHIP_CLOSE_ADD_MEMBERS_TO_MEMBERSHIP_GROUP_MODAL = 'membershipCloseAddMembersToMembershipGroupModal'

export const MEMBERSHIP_OPEN_EDIT_MEMBERSHIP_GROUP_MODAL = 'membershipOpenEditMembershipGroupModal'
export const MEMBERSHIP_CLOSE_EDIT_MEMBERSHIP_GROUP_MODAL = 'membershipCloseEditMembershipGroupModal'

export const MEMBERSHIP_OPEN_UPLOAD_MEMBER_CSV_MODAL = 'membershipOpenUploadMemberCSVModal'
export const MEMBERSHIP_CLOSE_UPLOAD_MEMBER_CSV_MODAL = 'membershipCloseUploadMemberCSVModal'

export const MEMBERSHIP_SET_MEMBERSHIP_GROUP_TYPES = 'membershipSetMembershipGroupTypes'
export const MEMBERSHIP_SET_MEMBERSHIPS = 'membershipSetMemberships'


export const MEMBERSHIP_SET_MEMBERSHIP = 'membershipSetMembership'

export const MEMBERSHIP_OPEN_REMOVE_MEMBERSHIP_FROM_MEMBERSHIP_GROUP_MODAL = 'membershipOpenRemoveMembershipFromMembershipGroupModal'
export const MEMBERSHIP_CLOSE_REMOVE_MEMBERSHIP_FROM_MEMBERSHIP_GROUP_MODAL = 'membershipCloseRemoveMembershipFromMembershipGroupModal'

export const MEMBERSHIP_OPEN_DEACTIVATE_MEMBERSHIP_MODAL = 'membershipOpenDeactivateMembershipModal'
export const MEMBERSHIP_CLOSE_DEACTIVATE_MEMBERSHIP_MODAL = 'membershipCloseDeactivateMembershipModal'

export const MEMBERSHIP_OPEN_REACTIVATE_MEMBERSHIP_MODAL = 'membershipOpenReactivateMembershipModal'
export const MEMBERSHIP_CLOSE_REACTIVATE_MEMBERSHIP_MODAL = 'membershipCloseReactivateMembershipModal'

export const MEMBERSHIP_OPEN_DELETE_MEMBERSHIP_MODAL = 'membershipOpenDeleteMembershipModal'
export const MEMBERSHIP_CLOSE_DELETE_MEMBERSHIP_MODAL = 'membershipCloseDeleteMembershipModal'

export const MEMBERSHIP_OPEN_INVITE_MEMBERSHIP_MODAL = 'membershipOpenInviteMembershipModal'
export const MEMBERSHIP_CLOSE_INVITE_MEMBERSHIP_MODAL = 'membershipCloseInviteMembershipModal'

export const MEMBERSHIP_START_RUNNING_MEMBERSHIP_REPORT = 'membershipStartRunningMembershipReport'
export const MEMBERSHIP_STOP_RUNNING_MEMBERSHIP_REPORT = 'membershipStopRunningMembershipReport'

export const MEMBERSHIP_SET_MEMBERSHIP_REPORTS = 'membershipSetMembershipReports'
export const MEMBERSHIP_SET_AVAILABLE_REPORT_COLUMNS = 'membershipSetAvailableReportColumns'
export const MEMBERSHIP_SET_AVAILABLE_REPORT_FILTERS = 'membershipSetAvailableReportFilters'
export const MEMBERSHIP_SET_MEMBERSHIP_REPORT = 'membershipSetMembershipReport'

export const MEMBERSHIP_TOGGLE_SELECTED_MEMBERSHIP = 'membershipToggleSelectedMembership'
export const MEMBERSHIP_TOGGLE_ALL_SELECTED_MEMBERSHIPS = 'membershipToggleAllSelectedMemberships'

export const MEMBERSHIP_CLOSE_DELETE_MEMBERSHIP_GROUP_MODAL = 'membershipCloseDeleteMembershipGroupModal'
export const MEMBERSHIP_OPEN_DELETE_MEMBERSHIP_GROUP_MODAL = 'membershipOpenDeleteMembershipGroupModal'